<template>
  <div>
    <van-popup
      v-model="isView"
      position="right"
      :style="{ height: '100%', width: '100%', background: '#f5f5f5' }"
    >
      <div>
        <van-nav-bar fixed>
          <div slot="title">场室详情</div>
          <div slot="left" @click="close">
            <van-icon name="arrow-left" color="#333" size="19" />
          </div>
        </van-nav-bar>
        <div class="edit-wrap">
          <div>
            <van-cell-group>
              <van-cell title="场室名称" :value="houseRow.HouseName" />
              <van-cell title="简称" :value="houseRow.HouseFullName" />
              <van-cell title="容纳人数" :value="`${houseRow.Volume}人`" />
              <van-cell title="所属楼层" :value="houseRow.Floor" />
              <van-cell title="所属校区" :value="houseRow.SchoolDistrictName" />
              <van-cell title="所属楼宇" :value="houseRow.BuildingName" />
              <van-cell title="场室类别" :value="houseRow.HousetypeName" />
            </van-cell-group>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  name: "ViewBuild",
  props: {
    isView: Boolean,
    rows: {}
  },
  data() {
    return {
      houseRow: {}
    };
  },
  watch: {
    rows: {
      handler(val) {
        if (val) {
          this.houseRow = val;
        }
      },
      deep: true
    },
    immediate: true
  },
  methods: {
    close() {
      this.$emit("listenToChildClose", false);
    }
  }
};
</script>
<style lang="less" scoped>
.edit-title {
  text-align: center;
  height: 80px;
  line-height: 80px;
}

.edit-wrap {
  margin-top: 110px;

  .custom-title {
    margin-left: 100px;
  }

  .tips-name {
    color: #ccc;
    font-size: 24px;
    padding-left: 20px;
    margin: 20px 0;
  }

  .group-bottom {
    margin-bottom: 20px;
  }

  .edit-build-btn {
    position: fixed;
    width: 100%;
    bottom: 0;
    height: 120px;
    background: #ffffff;
    align-items: center;

    .btn-left {
      margin-right: 80px;
    }

    button {
      width: 30%;
    }
  }
}
</style>
